import React from 'react';
import { Layout, PageHeader } from 'antd';
import UploadWidget from './uploadWidgets/uploadWidget';
import UploadDataList from './uploadWidgets/uploadDataList';
import UploadSuccess from './uploadWidgets/uploadSuccess';
import {
  clearUploadTypologies,
  confirmUploadedTypologies,
  discardUploadedTypologies
} from '../../../redux/actions/trm/trmDashboard';
import { connect } from 'react-redux';
import Proptypes from 'prop-types';

const { Header, Content, Footer } = Layout;

/**
 * TRM_Upload Page
 */
class TRM_Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isStepOne: true,
      isStepTwo: false,
      isStepThree: false,
      uploadedData: ''
    };
  }

  componentWillUnmount() {
    this.props.clearUploadTypologies();
  }

  /**
   * isFileUploadedFunc
   * @param isFileUploadedStatus
   * @param uploadedData
   */
  isFileUploadedFunc = (isFileUploadedStatus, uploadedData) => {
    this.setState({
      isStepOne: !isFileUploadedStatus,
      uploadedData: uploadedData,
      isStepTwo: isFileUploadedStatus
    });
  };

  /**
   * onUploadConfirm
   */
  onUploadConfirm = () => {
    this.setState({
      isStepOne: false,
      isStepTwo: false,
      isStepThree: true
    });
  };

  /**
   * onUploadAgain
   */
  onUploadAgain = () => {
    this.setState({
      isStepOne: true,
      uploadedData: '',
      isStepTwo: false,
      isStepThree: false
    });
  };

  render() {
    const { isStepOne, isStepTwo, isStepThree } = this.state;
    return (
      <Layout className="layout">
        <PageHeader
          ghost={false}
          onBack={() => {
            window.history.back();
            this.props.clearUploadTypologies();
          }}
          title="Typology Upload"></PageHeader>

        {isStepOne && (
          <UploadWidget isFileUploadedFunc={this.isFileUploadedFunc} />
        )}

        {isStepTwo && (
          <UploadDataList
            uploadedData={this.state.uploadedData}
            onConfirm={this.onUploadConfirm}
            onUploadAgain={this.onUploadAgain}
          />
        )}

        {isStepThree && <UploadSuccess />}
      </Layout>
    );
  }
}

TRM_Upload.propTypes = {
  clearUploadTypologies: Proptypes.func
};

export default TRM_Upload;
